<template>
<b-card class="section">
  <span class="empty-message">
    <slot></slot>
  </span>
</b-card>
</template>
<script>
export default {
  name: 'EmptyCard'
}

</script>
<style scoped>
.card.section {
  margin-bottom: 2rem;
  border-radius: 30px;
  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  padding: calc(2.0833vw - 10px) 2.0833vw 2.0833vw;
  width: 100%;
  height: 60vh;
}
.card.section .card-body {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
}
.empty-message {
  font-size: 1.4rem;
  color: rgb(200, 200, 200);
  font-weight: bold;
  font-family: 'NanumGothic';
}
</style>